<div class="login">
  <div class="login__wrapper">
    <div class="login__wrapper__particle-first"></div>
    <div class="login__wrapper__particle-second"></div>
    <div class="login__wrapper__particle-third"></div>
  </div>
  <div class="login__logo">
    <div class="login__logo__shadow"></div>
    <span class="login__logo__ball"></span>
    <span class="login__logo__one"></span>
    <span class="login__logo__two"></span>
    <span class="login__logo__three"></span>
  </div>
  <div class="login__container">
    <h1>Bienvenido a Creci</h1>
    <app-button
      *ngIf="!loading"
      [titulo]="'Inicia sesión con Google'"
      (click)="handleLogin()"
      [className]="'quaternary login-button'"
      [icon]="'assets/icons/icon-google.svg'"></app-button>
    <app-loading *ngIf="loading"></app-loading>
  </div>
</div>
